// used to manage equal height of the Best of Hero cards VC components
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';

const doEqualHeight = () => {
    $(document).ready(() => {
        const cardsContainer = document.querySelectorAll(
            '.best-of-hero-card-container'
        );

        if (cardsContainer.length > 0) {
            // check for existence of container

            let maxHeight = -1;
            let elems = document.querySelectorAll(
                '.best-of-hero-card .features-container'
            );
            elems = [].slice.call(elems); // now a true array

            elems.forEach((e) => {
                // reset
                e.style.height = 'auto';
            });

            elems.forEach((e) => {
                maxHeight = Math.max(maxHeight, e.offsetHeight);
            });

            elems.forEach((e) => {
                if (MediaQuery.current !== 'small') {
                    e.style.height = `${maxHeight}px`;
                } else {
                    e.style.height = 'auto';
                }
            });

            $(window).resize(() => {
                // debounce(doEqualHeight(), 1000);
                clearTimeout(window.resizedFinished);
                window.resizedFinished = setTimeout(() => {
                    // console.log('Resized finished.');
                    doEqualHeight();
                }, 250);
            });
        }
    });
};

// module startup
const init = () => {
    doEqualHeight();
};

export { init };
